
import { defineComponent } from "vue";

export default defineComponent({
  name: "Loading",

  props: {
    width: {
      type: String,
      default: "30px",
      required: false
    },

    height: {
      type: String,
      default: "30px",
      required: false
    }
  },

  computed: {
    iconSize(): string {
      return `width: ${this.width}; height: ${this.height};`;
    }
  }
});
